import { ChangeDetectionStrategy, Component, computed, input, signal, WritableSignal } from '@angular/core';
import { FaqItem } from '../../models';
import { NgClass } from '@angular/common';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { CookiePreferences, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { sign } from 'crypto';

@Component({
    selector: 'app-faq-accordion',
    imports: [StripEmbedPipe, ResizeHtmlImagesPipe, SafePipe, MatAccordion, MatExpansionModule, NgClass],
    templateUrl: './faq-accordion.component.html',
    styleUrl: './faq-accordion.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqAccordionComponent {
  faqItems = input<FaqItem[]>();
  cookiePreferences = input<CookiePreferences>();
  cssClasses = input<string>();
  hasBorderAround = input<boolean>(false);

  openPanelIndex = signal<number | undefined>(undefined);
}
